/* eslint-disable no-console */
import React, { useContext } from 'react';
import BusinessSideNav from './components/BusinessSideNav';
import './styles.css';
import { HamburgerContext } from '../../libs/Context';
import { useSelector } from 'react-redux';

const SideNav = () =>
{
	const { contactHamBurger, showSideNavIcons } = useContext(HamburgerContext);
	const activePath = window.location.pathname.split('/')[1];
	const session = useSelector((state: any) => state?.mysession?.session);

	const paths = [ '/profileSettings', '/createNewTemplate' ];
	const isContactOrSettingsPath = paths.includes(`/${activePath}`) || (session?.empRole !== 'employee' && [ '/businessSettings' ]?.includes(`/${activePath}`));
	const className = `flexCol ${showSideNavIcons ? 'resMobSideNav' : ' resSideNav'} ${(isContactOrSettingsPath || contactHamBurger) ? 'resWidth' : ''}`;

	return (
		<>
			<div className={className}>
				<BusinessSideNav/>
			</div>
		</>
	);
};

export default SideNav;